import { render, staticRenderFns } from "./navButtonSetting.vue?vue&type=template&id=6cf4cca9&scoped=true&"
import script from "./navButtonSetting.vue?vue&type=script&lang=js&"
export * from "./navButtonSetting.vue?vue&type=script&lang=js&"
import style0 from "./navButtonSetting.vue?vue&type=style&index=0&id=6cf4cca9&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cf4cca9",
  null
  
)

export default component.exports